/**
 * Dev-only console logging for hot code paths.
 *
 * The API client and auth flow trace every request / auth check. In
 * production those lines flood the console, bury real errors and leak
 * request detail (URLs, CSRF state), so they only emit on dev builds.
 *
 * Genuine failure paths must NOT use these - keep `console.error` (or a
 * user-facing toast via `useNotify`) so production problems stay visible.
 */
const enabled = import.meta.env.DEV

export const debugLog: typeof console.log = enabled
  ? console.log.bind(console)
  : () => {}

export const debugWarn: typeof console.warn = enabled
  ? console.warn.bind(console)
  : () => {}
